<template>
    <div>
        <el-dialog title="Full Pattern Editor"
                   :visible.sync="show_full_pattern_dialog">
            <full-pattern-editor
                    :show_bleeding_edge="show_bleeding_edge"
                    :extentId="selected_extent"
                    @newFullPatternAndScrape="newFullPatternAndScrape"
                    @newFullPattern="newFullPattern"
                    @updateFullPattern="updatedFullPattern"
                    @updateFullPatternAndScrape="updatedFullPatternAndScrape"
                    :editedFullPattern="editedFullPattern"
            />
        </el-dialog>
        <div class="panel panel-default">
            <div class="panel-heading">Add Metadata by Scraping</div>
                <div class="panel-body">
                  <div style="margin-bottom:5px;"><strong>Use existing full pattern</strong></div>
                    <el-select filterable v-model="selected_full_pattern" placeholder="Select the pattern to scrape">
                        <el-option
                                v-for="item in available_full_patterns"
                                :key = "item.id"
                                :label = "item.name"
                                :value = "item.id">
                        </el-option>
                    </el-select>
                  <!-- <el-button v-on:click="" icon="el-icon-edit"></el-button> -->
                  <div style="margin-bottom:10px;">
                    <el-button type="primary" style="margin-top:4px" v-on:click="startSpecificScrape()">Scrape</el-button>
                    <input type="checkbox" id="checkbox" v-model="checked">
                    <label for="checkbox">Use Cache</label>
                  </div>

                  <div style="margin-bottom:5px;"><strong>Create new pattern</strong></div>
                  <div>
                      <el-button v-on:click="showFullPatternEditor(null)">New Pattern</el-button>
                  </div>
                    <p>Need to scrape off other information? Contact us.</p>
                </div>
        </div>
        <div v-if="existing_full_patterns_by_suite && existing_full_patterns_by_suite.length>0" class="panel panel-default">
            <div class="panel-heading">Current Patterns for This Extent</div>
                <div class="panel-body">
                  <el-button type="primary" style="margin-top:4px" v-on:click="startAllScrape">Scrape All</el-button>
                  <p>Scraping any current pattern goes against the cache for speed.</p>
                    <div v-for="suite in existing_full_patterns_by_suite" style="border-top: 1px solid black;padding-top:10px;">
                        <span><em>{{suite.name}}</em></span>
                        <el-button v-if="existing_full_patterns_by_suite.length>1" style="float:right;" @click="scrapeSuite(suite.id)">Scrape these</el-button>
                        <ul  style="margin-top:12px;">
                            <li v-for="pattern in suite.full_patterns" style="margin-bottom:9px;">
                              <span style="margin-right:4px;">{{pattern.name}}</span>
                              <el-button
                                  icon="el-icon-caret-right"
                                  size="mini"
                                  circle
                                  v-on:click="startSpecificScrape(pattern.id)"></el-button>
                              <el-button
                                  v-if="pattern.id>=10000"
                                  icon="el-icon-edit"
                                  size="mini"
                                  circle
                                  v-on:click="showFullPatternEditor(pattern)"></el-button>
                            </li>
                        </ul>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
    import ElOption from "../../../../node_modules/element-ui/packages/select/src/option.vue";

    export default {
        props: ['selected_extent'],
        components: {ElOption},
        mounted() {
            if (chimera.permissions.includes('BLEEDING_EDGE')) this.show_bleeding_edge = true
          this.loadExtent()
        },
        data() {
            return {
                extents: '',
                checked: true,
                show_bleeding_edge: false,
                show_full_pattern_dialog: false,
                selected_full_pattern: null,
                available_full_patterns: null,
                existing_full_patterns_by_suite: null,
                editedFullPattern: null,
            }
        },
        watch: {
            selected_extent: function(newVal,oldVal) {
                if (newVal != oldVal) this.loadExtent()
            }
        },
        methods: {
            newFullPattern(fullPattern) {
                this.selected_full_pattern = null
                if (this.existing_full_patterns_by_suite && this.existing_full_patterns_by_suite[0] && this.existing_full_patterns_by_suite[0].full_patterns) {
                  this.existing_full_patterns_by_suite[0].full_patterns.push(fullPattern)
                } else {
                  this.existing_full_patterns_by_suite[0] = {}
                  this.existing_full_patterns_by_suite[0].id = -1
                  this.existing_full_patterns_by_suite[0].name = "Extent-specific patterns"
                  this.existing_full_patterns_by_suite[0].full_patterns = []
                  this.existing_full_patterns_by_suite[0].full_patterns.push(fullPattern)
                }
                this.show_full_pattern_dialog = false
            },
            newFullPatternAndScrape(fullPattern) {
              this.selected_full_pattern = fullPattern.id
              this.startSpecificScrape()
            },
            updatedFullPattern(fullPattern) {
                console.log('in Scrape component updatedFullPattern')
                this.selected_full_pattern = null
                this.existing_full_patterns_by_suite[0].full_patterns = this.existing_full_patterns_by_suite[0].full_patterns.filter(function(full_pattern, index, arr){
                  return full_pattern.id !== fullPattern.id
                });
                this.existing_full_patterns_by_suite[0].full_patterns.push(fullPattern)
                this.show_full_pattern_dialog = false
            },
            updatedFullPatternAndScrape(fullPattern) {
              console.log('in Scrap component updatedFullPatternAndScrape')
              this.selected_full_pattern = fullPattern.id
              this.startSpecificScrape()
            },
            showFullPatternEditor(pattern) {
                if (pattern) {
                  this.editedFullPattern = pattern
                } else {
                  this.editedFullPattern = null
                }
                this.show_full_pattern_dialog = true
            },
            loadExtent() {
                if (this.selected_extent) {
                  axios.get('/api/fullpatterns/' + this.selected_extent)
                      .then(response => {
                        this.available_full_patterns = response.data.available_flat
                        this.existing_full_patterns_by_suite = response.data.current_by_suite
                      })
                      .catch(error => {
                        console.log('oops getting full patterns')
                      })
                }
            },
            startScrape(id=null,full_pattern_suite_id=null) {
                axios.post('/api/jobChains', {
                    extent_id: this.selected_extent,
                    type: "scrape",
                    full_pattern_id: id,
                    try_cache: this.checked,
                    full_pattern_suite_id: full_pattern_suite_id,
                }).then(response => {
                    window.location.href = '/progress/' + response.data.job_chain_id
                }).catch(error => {
                    console.log('oops problem starting scrape job')
                    console.log(error.response)
                })
            },
            startAllScrape() {
                this.startScrape()
            },
            startSpecificScrape(full_pattern) {
                if (!full_pattern) {
                  full_pattern = this.selected_full_pattern
                }
                this.startScrape(full_pattern)
            },
            scrapeSuite(suite_id) {
                this.startScrape(null,suite_id)
            },
            handleCheckChangeParent(selected_extent) {
                // console.log("handling check change from child")
                // console.log("select extent id back in parent:")
                // console.log(selected_extent)
                this.selected_extent = selected_extent.id
            },
        }
    }
</script>